export const PAGE_UI_RIGHTSIDER_TOGGLE = 'PAGE_UI_RIGHTSIDER_TOGGLE';
export const PAGE_UI_RIGHTSIDER_SETTING = 'PAGE_UI_RIGHTSIDER_SETTING';



// WEBPACK FOOTER //
// ./src/components/page/RightSider/flow/actionType.js